/* ==========================================================================
   TREVORY — Favoritos (wishlist) e Vistos recentemente
   Tudo fica salvo no navegador da cliente (localStorage), sem app.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.tvShop || {};
  var WISH_KEY = 'tv_wishlist';
  var RECENT_KEY = 'tv_recent';

  /* ---------- armazenamento ---------- */
  function read(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  }
  function write(key, list) {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }

  /* ---------- dinheiro (mesmo formato da loja) ---------- */
  function money(cents) {
    var fmt = cfg.moneyFormat || '£{{amount}}';
    var n = (cents || 0) / 100;
    function f(d, t, s) {
      var p = n.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return p.join(s);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return f(0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(0, '.', ',');
      if (k === 'amount_with_space_separator') return f(2, ' ', ',');
      return f(2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* ---------- buscar produtos ---------- */
  var cache = {};
  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    var root = (cfg.root || '/').replace(/\/$/, '');
    cache[handle] = fetch(root + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (r.status === 404) return { __gone: true }; return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  /* ---------- card (mesmas classes da grade do tema) ---------- */
  function cardHTML(p) {
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var img2 = p.images && p.images[1];
    var price = onSale
      ? '<div class="price price--on-sale"><div class="price__container"><div class="price__sale">' +
        '<span class="price-item price-item--sale price-item--last">' + money(p.price) + '</span>' +
        '<s class="price-item price-item--regular">' + money(p.compare_at_price) + '</s></div></div></div>'
      : '<div class="price"><div class="price__container"><div class="price__regular">' +
        '<span class="price-item price-item--regular">' + money(p.price) + '</span></div></div></div>';
    return '' +
      '<li class="tv-rail__item">' +
        '<div class="card-wrapper product-card-wrapper">' +
          '<div class="card card--standard card--media">' +
            '<div class="card__inner ratio" style="--ratio-percent:125%">' +
              '<div class="card__media"><div class="media media--transparent media--hover-effect">' +
                (img ? '<img src="' + imgUrl(img, 533) + '" alt="' + esc(p.title) + '" loading="lazy" width="533" height="666">' : '') +
                (img2 ? '<img src="' + imgUrl(img2, 533) + '" alt="" loading="lazy" width="533" height="666">' : '') +
              '</div></div>' +
              (onSale ? '<div class="card__content"><div class="card__badge top left"><span class="badge">Sale</span></div></div>' : '') +
              wishButtonHTML(p.handle) +
            '</div>' +
            '<div class="card__content"><div class="card__information">' +
              '<h3 class="card__heading h5"><a class="full-unstyled-link" href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
              '<div class="card-information">' + price + '</div>' +
            '</div></div>' +
          '</div>' +
        '</div>' +
      '</li>';
  }

  /* ---------- favoritos ---------- */
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M19.5 5.6a4.9 4.9 0 0 0-6.9 0L12 6.2l-.6-.6a4.9 4.9 0 0 0-6.9 6.9l.6.6L12 19.9l6.9-6.8.6-.6a4.9 4.9 0 0 0 0-6.9z"/></svg>';

  function wishButtonHTML(handle) {
    return '<button type="button" class="tv-wish" data-tv-wish="' + esc(handle) + '" aria-pressed="false" aria-label="Add to wishlist">' + HEART + '</button>';
  }

  function inWish(handle) { return read(WISH_KEY).indexOf(handle) !== -1; }

  function toggleWish(handle) {
    var list = read(WISH_KEY);
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle); else list.splice(i, 1);
    write(WISH_KEY, list.slice(0, 60));
    syncWish();
    return i === -1;
  }

  function syncWish() {
    var list = read(WISH_KEY);
    document.querySelectorAll('[data-tv-wish]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-tv-wish')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      var label = btn.querySelector('[data-tv-wish-label]');
      if (label) label.textContent = on ? (label.dataset.on || 'Saved to wishlist') : (label.dataset.off || 'Add to wishlist');
    });
    document.querySelectorAll('[data-tv-wish-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tv-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggleWish(btn.getAttribute('data-tv-wish'));
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    if (added) btn.classList.add('is-pop');
    toast(added);
    var page = btn.closest('[data-tv-wishlist-page]');
    if (page && !added) renderWishlistPage(page);
  }, true);

  /* ---------- aviso delicado ao salvar / remover ---------- */
  var toastEl = null;
  var toastTimer = null;
  function toast(added, message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'tv-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    var root = (cfg.root || '/').replace(/\/$/, '');
    toastEl.innerHTML = message ? '<span>' + esc(message) + '</span>' : added
      ? HEART.replace('<svg', '<svg class="tv-toast__icon"') +
        '<span>' + esc(cfg.wishAdded || 'Saved to your wishlist') + '</span>' +
        '<a class="tv-toast__link" href="' + root + '/pages/wishlist">' + esc(cfg.wishView || 'View') + '</a>'
      : '<span>' + esc(cfg.wishRemoved || 'Removed from wishlist') + '</span>';
    toastEl.classList.toggle('tv-toast--removed', !added && !message);
    toastEl.classList.remove('is-visible');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- gaveta de favoritos (abre pelo coração do topo e pelo "View") ---------- */
  var drawer = null;
  function buildDrawer() {
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.className = 'tv-wd';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML =
      '<div class="tv-wd__overlay" data-tv-wd-close></div>' +
      '<aside class="tv-wd__panel" role="dialog" aria-modal="true" aria-label="' + esc(cfg.wishTitle || 'Wishlist') + '">' +
        '<header class="tv-wd__head">' +
          '<p class="tv-wd__title">' + esc(cfg.wishTitle || 'Wishlist') + ' <span data-tv-wd-count></span></p>' +
          '<button type="button" class="tv-wd__close" data-tv-wd-close aria-label="Close">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '</header>' +
        '<ul class="tv-wd__list" role="list" data-tv-wd-list></ul>' +
        '<div class="tv-wd__empty" data-tv-wd-empty hidden>' + HEART +
          '<p>' + esc(cfg.wishEmpty || 'Tap the heart on any piece to save it here.') + '</p></div>' +
      '</aside>';
    document.body.appendChild(drawer);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-tv-wd-close]')) { e.preventDefault(); closeDrawer(); }
      var rm = e.target.closest('[data-tv-wd-remove]');
      if (rm) { e.preventDefault(); toggleWish(rm.getAttribute('data-tv-wd-remove')); renderDrawer(); return; }
      var size = e.target.closest('[data-tv-wd-variant]');
      if (size && !size.disabled) { e.preventDefault(); addToBag(size.getAttribute('data-tv-wd-variant'), size); return; }
      var add = e.target.closest('[data-tv-wd-add]');
      if (add) {
        e.preventDefault();
        var direct = add.getAttribute('data-tv-wd-variant-direct');
        if (direct) { addToBag(direct, add); return; }
        var box = add.parentNode.querySelector('[data-tv-wd-sizes]');
        if (box) {
          box.hidden = !box.hidden;
          add.classList.toggle('is-choosing', !box.hidden);
          add.querySelector('span').textContent = box.hidden ? (cfg.wishAddToCart || 'Add to cart') : (cfg.wishChooseSize || 'Select a size');
        }
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    return drawer;
  }

  /* "Add to bag" na gaveta: 1 tamanho = adiciona direto; vários = mostra os tamanhos */
  function variantLabel(p, v) {
    if (p.options && p.options.length > 1) return v.public_title || v.title;
    return v.option1 || v.title;
  }
  function actionsHTML(p) {
    var variants = p.variants || [];
    if (!p.available) {
      return '<button type="button" class="tv-wd__add" disabled>' + esc(cfg.wishSoldOut || 'Sold out') + '</button>';
    }
    var single = variants.length <= 1;
    var chips = single ? '' : '<div class="tv-wd__sizes" data-tv-wd-sizes hidden>' + variants.map(function (v) {
      return '<button type="button" class="tv-wd__size" data-tv-wd-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(variantLabel(p, v)) + '</button>';
    }).join('') + '</div>';
    return '<button type="button" class="tv-wd__add" data-tv-wd-add="' + esc(p.handle) + '"' +
      (single && variants[0] ? ' data-tv-wd-variant-direct="' + variants[0].id + '"' : '') + '>' +
      '<span>' + esc(cfg.wishAddToCart || 'Add to cart') + '</span></button>' + chips;
  }

  function addToBag(variantId, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    var root = (cfg.root || '/').replace(/\/$/, '');
    fetch(root + '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        closeDrawer();
        if (typeof window.openCartDrawer === 'function') setTimeout(window.openCartDrawer, 120);
      })
      .catch(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
        showMessage(cfg.wishAddError || 'Could not add to cart. Please try again.');
      });
  }

  function showMessage(text) {
    toast(null, text);
  }

  function rowHTML(p) {
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    return '<li class="tv-wd__item">' +
      '<a class="tv-wd__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + imgUrl(img, 200) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
      '<div class="tv-wd__info">' +
        '<a class="tv-wd__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<p class="tv-wd__price">' + (onSale
          ? '<span class="tv-wd__sale">' + money(p.price) + '</span> <s>' + money(p.compare_at_price) + '</s>'
          : money(p.price)) + '</p>' +
        actionsHTML(p) +
      '</div>' +
      '<button type="button" class="tv-wd__remove" data-tv-wd-remove="' + esc(p.handle) + '" aria-label="Remove">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
    '</li>';
  }

  function renderDrawer() {
    var d = buildDrawer();
    var handles = read(WISH_KEY);
    var list = d.querySelector('[data-tv-wd-list]');
    var empty = d.querySelector('[data-tv-wd-empty]');
    d.querySelector('[data-tv-wd-count]').textContent = handles.length ? '(' + handles.length + ')' : '';
    if (!handles.length) { list.innerHTML = ''; empty.hidden = false; return; }
    empty.hidden = true;
    Promise.all(handles.map(fetchProduct)).then(function (products) {
      /* tira da lista só produtos que não existem mais na loja (404); falha de rede não apaga nada */
      var gone = handles.filter(function (h, i) { return products[i] && products[i].__gone; });
      if (gone.length) write(WISH_KEY, read(WISH_KEY).filter(function (h) { return gone.indexOf(h) === -1; }));
      var ok = products.filter(function (p) { return p && !p.__gone; });
      list.innerHTML = ok.map(rowHTML).join('');
      empty.hidden = ok.length > 0;
      d.querySelector('[data-tv-wd-count]').textContent = ok.length ? '(' + ok.length + ')' : '';
      syncWish();
    });
  }

  function openDrawer() {
    var d = buildDrawer();
    renderDrawer();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tv-wd-lock');
    if (toastEl) toastEl.classList.remove('is-visible');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tv-wd-lock');
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-tv-wd-open], .header__icon--wishlist, .tv-toast__link');
    if (!opener) return;
    e.preventDefault();
    /* se veio do menu do celular, fecha o menu antes */
    var menuClose = opener.closest('.menu-drawer') && document.querySelector('.menu-drawer__close-btn');
    if (menuClose) { menuClose.click(); setTimeout(openDrawer, 260); return; }
    openDrawer();
  });

  /* ---------- vistos recentemente ---------- */
  function trackRecent(handle) {
    if (!handle) return;
    var list = read(RECENT_KEY).filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(RECENT_KEY, list.slice(0, 12));
  }

  /* ---------- renderizar faixas ---------- */
  function renderList(handles, container, max) {
    return Promise.all(handles.slice(0, max).map(fetchProduct)).then(function (products) {
      var ok = products.filter(function (p) { return p && !p.__gone; });
      container.innerHTML = ok.map(cardHTML).join('');
      syncWish();
      return ok.length;
    });
  }

  function renderRecent(section) {
    var current = section.getAttribute('data-current') || '';
    var max = parseInt(section.getAttribute('data-limit'), 10) || 8;
    var handles = read(RECENT_KEY).filter(function (h) { return h !== current; });
    var list = section.querySelector('[data-tv-list]');
    if (!handles.length || !list) { section.hidden = true; return; }
    renderList(handles, list, max).then(function (n) { section.hidden = n === 0; });
  }

  function renderWishlistPage(section) {
    var list = section.querySelector('[data-tv-list]');
    var empty = section.querySelector('[data-tv-empty]');
    var handles = read(WISH_KEY);
    if (!handles.length) { list.innerHTML = ''; if (empty) empty.hidden = false; return; }
    renderList(handles, list, 60).then(function (n) { if (empty) empty.hidden = n > 0; });
  }

  /* ---------- entrada suave ao rolar (.tv-reveal) ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.tv-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    document.documentElement.classList.add('tv-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) el.classList.add('is-in'); else io.observe(el);
    });
  }

  /* O próprio produto não aparece nas recomendações dele */
  function hideCurrentProduct() {
    var pdp = document.querySelector('[data-tv-product-handle]');
    if (!pdp) return;
    var h = pdp.getAttribute('data-tv-product-handle').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var re = new RegExp('/products/' + h + '(?:[?#/]|$)');
    document.querySelectorAll('.tv-rail__item').forEach(function (li) {
      var a = li.querySelector('a[href*="/products/"]');
      if (a && re.test(a.getAttribute('href'))) li.remove();
    });
  }

  /* Banner "Adapt to image": altura = imagem que está na tela (sem recortar) */
  function initAdaptiveBanners() {
    document.querySelectorAll('.slideshow.banner--adapt_image').forEach(function (slider) {
      if (slider.dataset.tvAdapt) return;
      slider.dataset.tvAdapt = '1';
      var slides = slider.querySelectorAll('.slideshow__slide');
      if (!slides.length) return;
      var ticking = false;
      function fit() {
        ticking = false;
        var w = slider.clientWidth || 1;
        var i = Math.min(slides.length - 1, Math.max(0, Math.round(slider.scrollLeft / w)));
        var h = slides[i].offsetHeight;
        if (h) slider.style.height = h + 'px';
      }
      function queue() { if (!ticking) { ticking = true; requestAnimationFrame(fit); } }
      slider.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      slider.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', queue, { once: true }); });
      fit();
    });
  }

  /* ------------------------------------------------------------------
     Visualizador de fotos (zoom) da página de produto.
     Botão discreto na foto -> tela cheia limpa: pinça / duplo toque / clique / roda do mouse para ampliar,
     arrastar para ver detalhes, deslizar ou setas para trocar de foto. Só é montado quando alguém clica
     (nenhum peso extra antes disso) e não usa biblioteca.
     ------------------------------------------------------------------ */
  /* Textos do visualizador: só em inglês (a loja é em inglês) */
  var TV_ZOOM_EN = { close: 'Close', prev: 'Previous photo', next: 'Next photo', label: 'Product photos', touch: 'Pinch or double-tap to zoom', mouse: 'Click to zoom' };
  function zoomText() { return TV_ZOOM_EN; }
  var CLOSE_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var PREV_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m14.5 5.5-6.5 6.5 6.5 6.5"/></svg>';
  var NEXT_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9.5 5.5 6.5 6.5-6.5 6.5"/></svg>';

  var tvViewer = null;
  function getViewer() {
    if (tvViewer) return tvViewer;
    var L = zoomText();
    var root = document.createElement('div');
    root.className = 'tv-zoom notranslate';
    root.setAttribute('translate', 'no');   /* o tradutor automático do navegador (Chrome/Safari) não mexe nos textos do zoom: ficam em inglês */
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', L.label);
    root.innerHTML =
      '<div class="tv-zoom__top"><span class="tv-zoom__count" aria-live="polite"></span>' +
      '<button type="button" class="tv-zoom__btn tv-zoom__close" aria-label="' + L.close + '">' + CLOSE_ICON + '</button></div>' +
      '<div class="tv-zoom__stage"><img class="tv-zoom__img" alt="" draggable="false"></div>' +
      '<button type="button" class="tv-zoom__btn tv-zoom__nav tv-zoom__nav--prev" aria-label="' + L.prev + '">' + PREV_ICON + '</button>' +
      '<button type="button" class="tv-zoom__btn tv-zoom__nav tv-zoom__nav--next" aria-label="' + L.next + '">' + NEXT_ICON + '</button>' +
      '<p class="tv-zoom__hint"></p>';
    document.body.appendChild(root);

    var stage = root.querySelector('.tv-zoom__stage');
    var img = root.querySelector('.tv-zoom__img');
    var count = root.querySelector('.tv-zoom__count');
    var closeBtn = root.querySelector('.tv-zoom__close');
    var prevBtn = root.querySelector('.tv-zoom__nav--prev');
    var nextBtn = root.querySelector('.tv-zoom__nav--next');
    var hint = root.querySelector('.tv-zoom__hint');
    var MAX = 5;
    /* não deixa ampliar além do que a resolução da foto sustenta (evita imagem borrada) */
    function maxScale() {
      var w = img.offsetWidth || 1;
      return clamp((st.nw / w) * (window.devicePixelRatio || 1), 2.6, MAX);
    }
    var st = { items: [], i: 0, s: 1, x: 0, y: 0, nw: 0, nh: 0, onClose: null, opener: null, hintTimer: 0 };
    var ptrs = {}, pinch = null, drag = null, lastTap = { t: 0, x: 0, y: 0 }, closing = false;

    function hiUrl(u) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=2400') : u; }
    function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
    function avail() {
      var wide = window.innerWidth >= 750;
      return { w: stage.clientWidth - (wide ? 160 : 24), h: stage.clientHeight - (wide ? 120 : 110) };
    }
    function layout() {
      if (!st.nw || !st.nh) return;
      var a = avail();
      var fit = Math.min(a.w / st.nw, a.h / st.nh);
      img.style.width = Math.round(st.nw * fit) + 'px';
      img.style.height = Math.round(st.nh * fit) + 'px';
    }
    function bounds() {
      var mx = Math.max(0, (img.offsetWidth * st.s - stage.clientWidth) / 2);
      var my = Math.max(0, (img.offsetHeight * st.s - stage.clientHeight) / 2);
      return { x: mx, y: my };
    }
    function apply(animate) {
      var b = bounds();
      if (st.s <= 1.001) { st.s = 1; st.x = 0; st.y = 0; }
      else { st.x = clamp(st.x, -b.x, b.x); st.y = clamp(st.y, -b.y, b.y); }
      img.style.transition = animate ? 'transform .3s cubic-bezier(.22,1,.36,1)' : 'none';
      img.style.transform = 'translate3d(' + st.x + 'px,' + st.y + 'px,0) scale(' + st.s + ')';
      root.classList.toggle('is-zoomed', st.s > 1.01);
    }
    function zoomAt(cx, cy, s2, animate) {
      s2 = clamp(s2, 1, maxScale());
      var r = stage.getBoundingClientRect();
      var px = cx - (r.left + r.width / 2), py = cy - (r.top + r.height / 2);
      var k = s2 / st.s;
      st.x = px - (px - st.x) * k;
      st.y = py - (py - st.y) * k;
      st.s = s2;
      apply(animate);
    }
    function toggleZoom(cx, cy) { zoomAt(cx, cy, st.s > 1.05 ? 1 : 2.6, true); }

    function show(i) {
      st.i = (i + st.items.length) % st.items.length;
      var it = st.items[st.i];
      st.s = 1; st.x = 0; st.y = 0; st.nw = 0; st.nh = 0;
      img.style.transition = 'none'; img.style.transform = 'none';
      img.alt = it.alt || '';
      count.textContent = st.items.length > 1 ? (st.i + 1) + ' / ' + st.items.length : '';
      root.classList.toggle('is-single', st.items.length < 2);
      root.classList.remove('is-zoomed');
      var hi = hiUrl(it.src), mine = st.i;
      var low = new Image();
      low.onload = function () {
        if (st.i !== mine) return;
        st.nw = low.naturalWidth; st.nh = low.naturalHeight; img.src = low.src; layout();
        var big = new Image();
        big.onload = function () {
          if (st.i !== mine) return;
          if (big.naturalWidth && big.naturalHeight) { st.nw = big.naturalWidth; st.nh = big.naturalHeight; layout(); }
          img.src = big.src;
        };
        big.src = hi;
      };
      low.src = it.src;
      var nxt = st.items[(st.i + 1) % st.items.length];
      if (nxt && !(navigator.connection && navigator.connection.saveData)) { var pre = new Image(); pre.src = hiUrl(nxt.src); }
    }
    function go(d) { if (st.items.length > 1) show(st.i + d); }
    function showHint() {
      var L2 = zoomText();
      hint.textContent = (window.matchMedia && window.matchMedia('(hover: none)').matches) ? L2.touch : L2.mouse;
      hint.classList.add('is-on');
      clearTimeout(st.hintTimer);
      st.hintTimer = setTimeout(function () { hint.classList.remove('is-on'); }, 2600);
    }
    function open(items, index, onClose, opener) {
      if (!items.length) return;
      st.items = items; st.onClose = onClose; st.opener = opener; closing = false;
      root.hidden = false;
      document.documentElement.classList.add('tv-zoom-lock');
      show(index || 0);
      setTimeout(function () { root.classList.add('is-open'); closeBtn.focus({ preventScroll: true }); }, 10);
      showHint();
    }
    function close() {
      if (closing || root.hidden) return;
      closing = true;
      root.classList.remove('is-open');
      clearTimeout(st.hintTimer); hint.classList.remove('is-on');
      var done = function () {
        root.hidden = true; closing = false;
        document.documentElement.classList.remove('tv-zoom-lock');
        img.removeAttribute('src');
        if (st.onClose) st.onClose(st.i);
        if (st.opener && st.opener.focus) st.opener.focus({ preventScroll: true });
      };
      setTimeout(done, window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 230);
    }

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === '+' || e.key === '=') { zoomAt(window.innerWidth / 2, window.innerHeight / 2, st.s * 1.5, true); }
      else if (e.key === '-') { zoomAt(window.innerWidth / 2, window.innerHeight / 2, st.s / 1.5, true); }
      else if (e.key === 'Tab') {
        var f = [closeBtn].concat(st.items.length > 1 ? [prevBtn, nextBtn] : []);
        var idx = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(idx + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    });
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var s2 = st.s * Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0022));
      if (s2 < 1.04) s2 = 1;
      zoomAt(e.clientX, e.clientY, s2, false);
    }, { passive: false });

    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      try { stage.setPointerCapture(e.pointerId); } catch (x) {}
      ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(ptrs);
      if (ids.length === 2) {
        var a = ptrs[ids[0]], b = ptrs[ids[1]];
        pinch = { d: dist(a, b), s: st.s, mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2 };
        drag = null;
      } else if (ids.length === 1) {
        drag = { x0: e.clientX, y0: e.clientY, lx: e.clientX, ly: e.clientY, t0: Date.now(), moved: 0, type: e.pointerType };
      }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!ptrs[e.pointerId]) return;
      ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(ptrs);
      if (ids.length >= 2 && pinch) {
        var a = ptrs[ids[0]], b = ptrs[ids[1]];
        var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
        var s2 = clamp(pinch.s * dist(a, b) / pinch.d, 1, maxScale());
        zoomAt(pinch.mx, pinch.my, s2, false);
        st.x += mx - pinch.mx; st.y += my - pinch.my; pinch.mx = mx; pinch.my = my;
        apply(false);
      } else if (drag) {
        var dx = e.clientX - drag.lx, dy = e.clientY - drag.ly;
        drag.moved = Math.max(drag.moved, Math.hypot(e.clientX - drag.x0, e.clientY - drag.y0));
        drag.lx = e.clientX; drag.ly = e.clientY;
        if (st.s > 1.01) { st.x += dx; st.y += dy; apply(false); }
      }
    });
    function end(e) {
      if (!ptrs[e.pointerId]) return;
      delete ptrs[e.pointerId];
      var left = Object.keys(ptrs).length;
      if (pinch && left < 2) { pinch = null; if (st.s < 1.05) apply(true); }
      if (drag && left === 0) {
        var d = drag; drag = null;
        var dx = e.clientX - d.x0, dy = e.clientY - d.y0, dt = Date.now() - d.t0;
        if (e.type === 'pointercancel') return;
        if (d.moved < 7 && dt < 450) {
          if (d.type === 'mouse') { toggleZoom(e.clientX, e.clientY); }
          else {
            var now = Date.now();
            if (now - lastTap.t < 320 && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 40) { toggleZoom(e.clientX, e.clientY); lastTap.t = 0; }
            else lastTap = { t: now, x: e.clientX, y: e.clientY };
          }
        } else if (st.s <= 1.01) {
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.3) go(dx < 0 ? 1 : -1);
          else if (dy > 110 && Math.abs(dx) < 80) close();
        }
      }
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    window.addEventListener('resize', function () { if (!root.hidden) { layout(); apply(false); } });
    img.addEventListener('dragstart', function (e) { e.preventDefault(); });

    tvViewer = { open: open, close: close, el: root, state: st, zoomAt: zoomAt, go: go };
    return tvViewer;
  }

  /* Galeria do produto: contador "1 / 7" na foto grande, degradê nas miniaturas
     e uma dica de arrastar (a fileira desliza um pouquinho e volta, 1x por visita) */
  function initGallery() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('media-gallery').forEach(function (g) {
      if (g.dataset.tvGallery) return;
      var slider = g.querySelector('.product__media-list');
      var host = g.querySelector('.product-media-slider');
      if (!slider || !host) return;
      g.dataset.tvGallery = '1';
      var thumbs = g.querySelector('.thumbnail-list');

      var badge = document.createElement('div');
      badge.className = 'tv-gcount';
      badge.setAttribute('aria-hidden', 'true');
      badge.hidden = true;
      host.appendChild(badge);

      /* (sem botão de lupa: o zoom abre tocando/clicando na própria foto) */
      var curSlide = null;
      function imageSlides() {
        return [].filter.call(slider.querySelectorAll('.product__media-item'), function (li) {
          return li.offsetParent !== null && li.querySelector('.media-type-image img');
        });
      }
      function openViewer(startSlide) {
        var slides = imageSlides();
        if (!slides.length) return;
        var start = Math.max(0, slides.indexOf(startSlide));
        var items = slides.map(function (li) {
          var im = li.querySelector('.media-type-image img');
          return { src: im.getAttribute('src') || im.currentSrc, alt: im.getAttribute('alt') || '', id: li.dataset.mediaId };
        });
        getViewer().open(items, start, function (i) {
          var li = slides[i];
          if (li && li !== curSlide) {
            if (g.setActiveMedia && li.dataset.mediaId) g.setActiveMedia(li.dataset.mediaId, false);
            else slider.scrollTo({ left: li.offsetLeft, behavior: 'instant' });
          }
        }, null);
      }
      /* tocar/clicar na própria foto também abre o zoom (um toque que vira rolagem/arrasto não conta) */
      slider.addEventListener('click', function (e) {
        if (e.defaultPrevented || !e.target.closest) return;
        if (e.target.closest('a, button, video, internal-video, model-viewer, iframe')) return;
        var li = e.target.closest('.product__media-item');
        if (!li || !li.querySelector('.media-type-image img')) return;
        openViewer(li);
      });

      /* vídeo da galeria: sinal de "carregando" e começa a baixar quando está perto de aparecer */
      g.querySelectorAll('.product__media-item internal-video video').forEach(function (v) {
        var iv = v.closest('internal-video'), li = v.closest('.product__media-item');
        if (!iv || v.dataset.tvVid) return;
        v.dataset.tvVid = '1';
        function busy(on) { iv.classList.toggle('tv-vloading', !!on); }
        v.addEventListener('play', function () { if (v.readyState < 3) busy(true); });
        v.addEventListener('waiting', function () { if (!v.paused) busy(true); });
        v.addEventListener('stalled', function () { if (!v.paused && v.readyState < 3) busy(true); });
        ['playing', 'pause', 'ended', 'error', 'emptied'].forEach(function (n) { v.addEventListener(n, function () { busy(false); }); });
        var saver = navigator.connection && navigator.connection.saveData;
        if (li && 'IntersectionObserver' in window && !saver) {
          var io = new IntersectionObserver(function (entries) {
            if (!entries[0].isIntersecting) return;
            io.disconnect();
            if (v.preload !== 'auto') v.preload = 'auto';
          }, { root: slider, rootMargin: '0px 60% 0px 60%' });
          io.observe(li);
        }
      });

      /* O tema só atualiza a miniatura 0,5s depois da foto parar; aqui ela acompanha na hora.
         Depois de um toque numa miniatura, espera a foto chegar para não piscar pelas do meio. */
      var lockUntil = 0;
      if (thumbs) thumbs.addEventListener('click', function () { lockUntil = Date.now() + 1300; });
      function syncThumb(slide) {
        if (!thumbs || !slide || Date.now() < lockUntil) return;
        var li = thumbs.querySelector('[data-target="' + slide.dataset.mediaId + '"]');
        if (!li) return;
        var btn = li.querySelector('button');
        if (btn.hasAttribute('aria-current')) return;
        thumbs.querySelectorAll('button[aria-current]').forEach(function (b) { b.removeAttribute('aria-current'); });
        btn.setAttribute('aria-current', 'true');
        var tr = thumbs.getBoundingClientRect(), lr = li.getBoundingClientRect();
        if (thumbs.scrollWidth > thumbs.clientWidth + 2) {
          if (lr.left < tr.left + 8 || lr.right > tr.right - 24) thumbs.scrollTo({ left: Math.max(0, thumbs.scrollLeft + (lr.left - tr.left) - 16), behavior: 'smooth' });
        } else if (thumbs.scrollHeight > thumbs.clientHeight + 2) {
          if (lr.top < tr.top || lr.bottom > tr.bottom) thumbs.scrollTo({ top: Math.max(0, thumbs.scrollTop + (lr.top - tr.top) - 8), behavior: 'smooth' });
        }
      }

      var ticking = false;
      function update() {
        ticking = false;
        var list = [].filter.call(slider.querySelectorAll('.product__media-item'), function (li) { return li.offsetParent !== null; });
        var scrollable = slider.scrollWidth > slider.clientWidth + 2;
        curSlide = list[0] || null;
        if (list.length < 2 || !scrollable) { badge.hidden = true; }
        else {
          var base = slider.getBoundingClientRect().left, best = 0, min = Infinity;
          list.forEach(function (li, i) {
            var d = Math.abs(li.getBoundingClientRect().left - base);
            if (d < min) { min = d; best = i; }
          });
          badge.textContent = (best + 1) + ' / ' + list.length;
          badge.hidden = false;
          curSlide = list[best];
          syncThumb(list[best]);
        }
        if (thumbs) thumbs.classList.toggle('tv-more', thumbs.scrollLeft + thumbs.clientWidth < thumbs.scrollWidth - 6);
      }
      function queue() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      slider.addEventListener('scroll', queue, { passive: true });
      if (thumbs) thumbs.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      if ('MutationObserver' in window) new MutationObserver(queue).observe(slider, { subtree: true, attributes: true, attributeFilter: ['class'] });
      slider.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', queue, { once: true }); });
      update();

      /* dica de arrastar */
      var seen = false;
      try { seen = sessionStorage.getItem('tv_ghint') === '1'; } catch (e) {}
      if (!thumbs || seen || reduce || !('IntersectionObserver' in window)) return;
      var cancelled = false;
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { thumbs.addEventListener(ev, function () { cancelled = true; }, { passive: true, once: true }); });
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        setTimeout(function () {
          if (cancelled || thumbs.scrollLeft > 4 || thumbs.scrollWidth <= thumbs.clientWidth + 24) return;
          try { sessionStorage.setItem('tv_ghint', '1'); } catch (e) {}
          thumbs.style.scrollSnapType = 'none';
          thumbs.scrollTo({ left: 56, behavior: 'smooth' });
          setTimeout(function () { if (!cancelled) thumbs.scrollTo({ left: 0, behavior: 'smooth' }); }, 750);
          setTimeout(function () { thumbs.style.scrollSnapType = ''; }, 1600);
        }, 500);
      }, { threshold: 0.9 });
      io.observe(thumbs);
    });
  }

  /* Carrossel "Produtos parecidos": setinhas (computador) + carrega mais produtos parecidos conforme a pessoa arrasta.
     A página já traz os primeiros cartões; o resto vem de /collections/NOME?view=tv-cards (24 cartões, bem leve),
     só quando a pessoa chega perto do fim da fileira. Não há limite: segue até acabar a lista.
     Para a página não pesar, só ficam desenhados os cartões perto da tela (uns 20); os demais ficam guardados na
     memória e voltam quando a pessoa arrasta até eles (o espaço deles é mantido para a rolagem continuar certa). */
  function relHandle(a) {
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function initRelMore(box, track, refresh) {
    var order = (box.dataset.order || '').split(',').filter(Boolean);
    var current = box.dataset.current;
    var present = {};
    var firstItems = [].slice.call(track.children).filter(function (el) { return el.classList.contains('tv-rel__item'); });
    firstItems.forEach(function (li) { var h = relHandle(li.querySelector('a[href*="/products/"]')); if (h) present[h] = 1; });
    var queue = order.filter(function (h) { return !present[h] && h !== current; });
    if (!queue.length || !('IntersectionObserver' in window) || !window.fetch) return;
    var root = box.dataset.root || '/';
    var sources = [box.dataset.pool, box.dataset.extra].filter(Boolean).map(function (h) { return { h: h, page: 1, pages: null, done: false }; });
    var cache = {}, loading = false, BATCH = 8;

    /* ---- lista "virtual": todos os cartões na memória, poucos no DOM ---- */
    var all = firstItems.map(function (li) { return li.innerHTML; });
    var nodes = {};
    firstItems.forEach(function (li, i) { nodes[i] = li; });
    var winA = 0, winB = all.length - 1, step = 0, gap = 12;
    var spL = document.createElement('li'), spR = document.createElement('li');
    spL.className = spR.className = 'tv-rel__gap'; spL.setAttribute('aria-hidden', 'true'); spR.setAttribute('aria-hidden', 'true');
    var sentinel = document.createElement('li');
    sentinel.className = 'tv-rel__more'; sentinel.setAttribute('aria-hidden', 'true'); sentinel.innerHTML = '<span></span>';

    function measure() {
      var li = track.querySelector('.tv-rel__item');
      if (!li) return;
      var cs = getComputedStyle(track);
      gap = parseFloat(cs.columnGap || cs.gap) || 12;
      step = li.getBoundingClientRect().width + gap;
    }
    function rebuild(force) {
      if (!step) measure();
      if (!step) return;
      var padL = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      var first = Math.floor(Math.max(0, track.scrollLeft - padL) / step);
      var vis = Math.ceil(track.clientWidth / step) + 1;
      var last = first + vis;
      var nearA = winA > 0 && first - winA < 4;
      var nearB = winB < all.length - 1 && winB - last < 4;
      if (!force && !nearA && !nearB) return;
      var a = Math.max(0, first - 9), b = Math.min(all.length - 1, last + 9);
      var frag = [];
      if (a > 0) { spL.style.width = Math.max(0, a * step - gap) + 'px'; frag.push(spL); }
      for (var i = a; i <= b; i++) {
        var li = nodes[i];
        if (!li) { li = document.createElement('li'); li.className = 'tv-rel__item'; li.innerHTML = all[i]; nodes[i] = li; }
        frag.push(li);
      }
      for (var k in nodes) { if (+k < a || +k > b) delete nodes[k]; }
      if (b < all.length - 1) { spR.style.width = Math.max(0, (all.length - 1 - b) * step - gap) + 'px'; frag.push(spR); }
      if (sentinel.isConnected || !done) frag.push(sentinel);
      var keep = track.scrollLeft;
      track.replaceChildren.apply(track, frag);
      if (Math.abs(track.scrollLeft - keep) > 1) track.scrollLeft = keep;
      winA = a; winB = b;
      if (window.tvWishlist && window.tvWishlist.sync) window.tvWishlist.sync();
    }

    var done = false;
    function fetchPage(src) {
      return fetch(root + 'collections/' + src.h + '?view=tv-cards&page=' + src.page, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var n = 0;
          if (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var meta = doc.querySelector('[data-tv-pages]');
            if (meta) src.pages = parseInt(meta.getAttribute('data-tv-pages'), 10) || 1;
            doc.querySelectorAll('li[data-tv-h]').forEach(function (li) { var h = li.getAttribute('data-tv-h'); if (h && !cache[h]) { cache[h] = li.innerHTML; n++; } });
          }
          src.page++;
          if (!html || !n || (src.pages && src.page > src.pages)) src.done = true;
        })
        .catch(function () { src.done = true; });
    }
    function missing(batch) { return batch.filter(function (h) { return !cache[h]; }); }
    function ensure(batch) {
      if (!missing(batch).length) return Promise.resolve();
      var src = sources.filter(function (s) { return !s.done; })[0];
      if (!src) return Promise.resolve();
      return fetchPage(src).then(function () { return ensure(batch); });
    }
    function loadMore() {
      if (loading || !queue.length) return;
      loading = true;
      var batch = queue.slice(0, BATCH);
      ensure(batch).then(function () {
        batch.forEach(function (h) { if (cache[h]) { all.push(cache[h]); delete cache[h]; } });
        queue = queue.slice(BATCH);
        loading = false;
        if (!queue.length || sources.every(function (s) { return s.done; }) && missing(queue).length === queue.length) {
          done = true; io.disconnect(); sentinel.remove(); queue = [];
        }
        rebuild(true);
        if (!done) { io.unobserve(sentinel); io.observe(sentinel); }
        refresh();
      });
    }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) loadMore();
    }, { root: track, rootMargin: '0px 700px 0px 0px' });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; rebuild(false); });
    }, { passive: true });
    window.addEventListener('resize', function () { step = 0; rebuild(true); });
    measure();
    track.appendChild(sentinel);
    io.observe(sentinel);
  }
  function initRelSlider() {
    document.querySelectorAll('[data-tv-rel]').forEach(function (box) {
      if (box.dataset.tvRelReady) return;
      var track = box.querySelector('.tv-rel__track');
      var prev = box.querySelector('.tv-rel__arrow--prev');
      var next = box.querySelector('.tv-rel__arrow--next');
      if (!track || !prev || !next) return;
      box.dataset.tvRelReady = '1';
      var ticking = false;
      function update() {
        ticking = false;
        var more = track.scrollWidth > track.clientWidth + 8;
        prev.hidden = next.hidden = !more;
        prev.disabled = track.scrollLeft < 6;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 6 && !track.querySelector('.tv-rel__more');
      }
      function queue() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      function go(dir) { track.scrollBy({ left: dir * Math.max(160, track.clientWidth * 0.8), behavior: 'smooth' }); }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      update();
      initRelMore(box, track, queue);
    });
  }

  /* Cartões de produto: a 2ª foto (só vista ao passar o mouse, em telas de 990px ou mais) vem "adormecida" no HTML
     (data-tv-srcset) e só é carregada em telas largas, quando o cartão está perto da tela. Em celular/tablet ela nunca
     aparece, então nem é baixada (era mais da metade das fotos de uma coleção). Funciona também com cartões que chegam
     depois (filtros, carrossel de parecidos). */
  function initCardHover() {
    if (window.__tvCardHover) return;
    window.__tvCardHover = 1;
    if (!window.matchMedia || !('IntersectionObserver' in window)) return wake(document);
    var mq = window.matchMedia('(min-width: 990px)');
    var io = null, pending = false;
    function upgrade(img) {
      var ss = img.getAttribute('data-tv-srcset'), s = img.getAttribute('data-tv-src');
      if (!ss) return;
      img.setAttribute('srcset', ss);
      if (s) img.setAttribute('src', s);
      img.removeAttribute('data-tv-srcset');
      img.removeAttribute('data-tv-src');
    }
    function wake(root) { root.querySelectorAll('img[data-tv-srcset]').forEach(upgrade); }
    function watch() {
      pending = false;
      if (!mq.matches) return;
      if (!io) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); upgrade(e.target); } });
        }, { rootMargin: '500px 0px' });
      }
      document.querySelectorAll('img[data-tv-srcset]').forEach(function (img) {
        if (!img.__tvWatch) { img.__tvWatch = 1; io.observe(img); }
      });
    }
    function queue() { if (!pending) { pending = true; setTimeout(watch, 120); } }
    watch();
    if (mq.addEventListener) mq.addEventListener('change', queue);
    if ('MutationObserver' in window) new MutationObserver(function (muts) {
      if (!mq.matches) return;
      for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { queue(); return; } }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    initReveal();
    initCardHover();
    initAdaptiveBanners();
    initGallery();
    initRelSlider();
    hideCurrentProduct();
    var pdp = document.querySelector('[data-tv-product-handle]');
    if (pdp) trackRecent(pdp.getAttribute('data-tv-product-handle'));
    document.querySelectorAll('[data-tv-recent]').forEach(renderRecent);
    document.querySelectorAll('[data-tv-wishlist-page]').forEach(renderWishlistPage);
    syncWish();
  }

  window.tvWishlist = { toggle: toggleWish, has: inWish, sync: syncWish };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('storage', function (e) { if (e.key === WISH_KEY) syncWish(); });

  /* Cards que chegam depois (filtros, recomendações): atualiza os corações */
  /* Só reage quando entram cards/corações novos (filtros, recomendações), não a cada animação */
  var pending = false;
  function relevant(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType === 1 && (n.matches('[data-tv-wish], .tv-rail__item') || n.querySelector('[data-tv-wish], .tv-rail__item'))) return true;
      }
    }
    return false;
  }
  new MutationObserver(function (mutations) {
    if (pending || !relevant(mutations)) return;
    pending = true;
    setTimeout(function () { pending = false; syncWish(); hideCurrentProduct(); initReveal(); }, 150);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });

  /* Brilho da descrição só anima enquanto está na tela (economiza bateria no celular) */
  if ('IntersectionObserver' in window) {
    var glow = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('is-onscreen', en.isIntersecting); });
    });
    document.querySelectorAll('.tv-desc').forEach(function (el) { glow.observe(el); });
  }
})();
